export default {
  dataIterator: {
    rowsPerPageText: 'Aantal per bladsy:',
    rowsPerPageAll: 'Alles',
    pageText: '{0}-{1} van {2}',
    noResultsText: 'Geen ooreenstemmende resultate is gevind nie',
    nextPage: 'Volgende bladsy',
    prevPage: 'Vorige bladsy'
  },
  dataTable: {
    rowsPerPageText: 'Rye per bladsy:'
  },
  noDataText: 'Geen data is beskikbaar nie',
  carousel: {
    prev: 'Vorige visuele',
    next: 'Volgende visuele'
  }
}
